'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.OpenSearchParameter = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _utils = require('./utils');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @module opensearch/parameter
 */

var typeRE = /{([a-zA-Z:]+)([?]?)}/;
var typeREglobal = /{([a-zA-Z:]+)([?]?)}/g;

function parseType(value) {
  var match = typeRE.exec(value);
  if (match) {
    return match[1];
  }
  return null;
}

function isMandatory(value) {
  return typeRE.exec(value)[2] !== '?';
}

function formatDate(value) {
  var pattern = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

  var rePattern = pattern ? new RegExp(pattern) : null;
  if (value instanceof Date) {
    var isoString = value.toISOString();
    var formatted = isoString;
    if (!rePattern || rePattern.test(formatted)) {
      return formatted;
    }

    // Try without milliseconds
    formatted = isoString.split('.')[0] + 'Z';
    if (!rePattern || rePattern.test(formatted)) {
      return formatted;
    }

    // Try without Zulu
    formatted = isoString.slice(0, -1);
    if (!rePattern || rePattern.test(formatted)) {
      return formatted;
    }

    // Try without Zulu and milliseconds
    formatted = isoString.split('.')[0];
    if (!rePattern || rePattern.test(formatted)) {
      return formatted;
    }

    // as fallback return the default ISO format
    return isoString;
  }
  return value;
}

function eoValueToString(value) {
  var isDate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var pattern = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : undefined;

  var convertDate = function convertDate(dateValue) {
    return formatDate(dateValue, pattern);
  };

  if (typeof value === 'string') {
    return value;
  } else if (typeof value === 'number') {
    return value.toString();
  } else if (isDate && value instanceof Date) {
    return convertDate(value);
  } else if (Array.isArray(value)) {
    if (isDate) {
      return '{' + value.map(convertDate).join(',') + '}';
    }
    return '{' + value.join(',') + '}';
  }

  var left = null;
  var right = null;
  if (Object.prototype.hasOwnProperty.call(value, 'min')) {
    left = '[' + (isDate ? convertDate(value.min) : value.min);
  } else if (Object.prototype.hasOwnProperty.call(value, 'minExclusive')) {
    left = ']' + (isDate ? convertDate(value.minExclusive) : value.minExclusive);
  }

  if (Object.prototype.hasOwnProperty.call(value, 'max')) {
    right = (isDate ? convertDate(value.max) : value.max) + ']';
  } else if (Object.prototype.hasOwnProperty.call(value, 'maxExclusive')) {
    right = (isDate ? convertDate(value.maxExclusive) : value.maxExclusive) + '[';
  }

  if (left !== null && right !== null) {
    return left + ',' + right;
  } else if (left !== null) {
    return left;
  }
  return right;
}

function _serializeValue(value, type, pattern) {
  switch (type) {
    case 'time:start':
    case 'time:end':
      return formatDate(value, pattern);
    case 'geo:box':
      if (Array.isArray(value)) {
        return value.join(',');
      }
      break;
    case 'geo:geometry':
      return (0, _utils.toWKT)(value);
    case 'eo:orbitNumber':
    case 'eo:track':
    case 'eo:frame':
    case 'eo:cloudCover':
    case 'eo:snowCover':
    case 'eo:startTimeFromAscendingNode':
    case 'eo:completionTimeFromAscendingNode':
    case 'eo:illuminationAzimuthAngle':
    case 'eo:illuminationZenithAngle':
    case 'eo:illuminationElevationAngle':
    case 'eo:minimumIncidenceAngle':
    case 'eo:maximumIncidenceAngle':
    case 'eo:acrossTrackIncidenceAngle':
    case 'eo:alongTrackIncidenceAngle':
    case 'eo:dopplerFrequency':
    case 'eo:incidenceAngleVariation':
      return eoValueToString(value, false, pattern);
    case 'eo:availabilityTime':
    case 'eo:creationDate':
    case 'eo:modificationDate':
    case 'eo:processingDate':
      return eoValueToString(value, true, pattern);
    default:
      break;
  }
  return value;
}

/**
 * Class to describe a single OpenSearch URL parameter.
 */

var OpenSearchParameter = exports.OpenSearchParameter = function () {
  /**
   * Class to describe a single OpenSearch URL parameter.
   * @param {string|string[]} type The type(s) of the parameter
   * @param {string} name The name of the parameter
   * @param {boolean} mandatory Whether the parameter is mandatory
   * @param {object[]} [options=null] The possible values for this parameter
   * @param {string} options[].label The label of the option
   * @param {string} options[].value The value of the option
   * @param {Number} [minExclusive=undefined] The minimum value allowed for this
                                              parameter (exclusive)
   * @param {Number} [maxExclusive=undefined] The maximum value allowed for this
                                              parameter (exclusive)
   * @param {Number} [minInclusive=undefined] The minimum value allowed for this
                                              parameter (inclusive)
   * @param {Number} [maxInclusive=undefined] The maximum value allowed for this
                                              parameter (inclusive)
   */
  function OpenSearchParameter(type, name, mandatory) {
    var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var minExclusive = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : undefined;
    var maxExclusive = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : undefined;
    var minInclusive = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : undefined;
    var maxInclusive = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : undefined;
    var pattern = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : undefined;

    _classCallCheck(this, OpenSearchParameter);

    this._type = type;
    this._name = name;
    this._mandatory = mandatory;
    this._options = options;
    this._minExclusive = minExclusive;
    this._maxExclusive = maxExclusive;
    this._minInclusive = minInclusive;
    this._maxInclusive = maxInclusive;
    this._pattern = pattern;
  }

  /**
   * The type of the parameter
   * @readonly
   */


  _createClass(OpenSearchParameter, [{
    key: 'combined',


    /**
     * Combines this parameter with the values of another parameter.
     * @param {OpenSearchParameter} other the other parameter
     * @returns {OpenSearchParameter} the combined parameter
     */
    value: function combined(other) {
      return new OpenSearchParameter(this.type, this.name, (0, _utils.isNullOrUndefined)(this.mandatory) ? other.mandatory : this.mandatory, (0, _utils.isNullOrUndefined)(this.options) ? other.options : this.options, (0, _utils.isNullOrUndefined)(this.minExclusive) ? other.minExclusive : this.minExclusive, (0, _utils.isNullOrUndefined)(this.maxExclusive) ? other.maxExclusive : this.maxExclusive, (0, _utils.isNullOrUndefined)(this.minInclusive) ? other.minInclusive : this.minInclusive, (0, _utils.isNullOrUndefined)(this.maxInclusive) ? other.maxInclusive : this.maxInclusive, (0, _utils.isNullOrUndefined)(this.pattern) ? other.pattern : this.pattern);
    }

    /**
     * Serialize the given value according to the internal type to be sent in a
     * request.
     * @param {Number|string|Date|array|object} value The value to serialize. The
     *                                                allowed types depend on the
     *                                                internal type.
     * @param {string} [type] For multi-parameters, this parameter indicates what
     *                        of the multiple values to serialize.
     * @returns {string} the serialized value.
     */

  }, {
    key: 'serializeValue',
    value: function serializeValue(value) {
      var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : undefined;

      var types = this.type;

      if (this.isMulti && type) {
        if (Array.isArray(value)) {
          return _serializeValue(value[this.types.indexOf(type)], type, this.pattern);
        } else if (Object.prototype.hasOwnProperty.call(value, type)) {
          return _serializeValue(value[type], type, this.pattern);
        }
        return _serializeValue(value, type, this.pattern);
      }
      return _serializeValue(value, types, this.pattern);
    }

    /**
     * Constructs a new OpenSearchParameter from a DOM-Node.
     * @param {DOMNode} node the node to create the parameter from.
     * @returns {OpenSearchParameter} the constructed parameters object.
     */

  }, {
    key: 'serialize',


    /**
     * Serialize the parameter to a simple object.
     * @returns {object} The serialized parameter
     */
    value: function serialize() {
      var values = {
        type: this._type,
        name: this._name,
        mandatory: this._mandatory,
        options: this._options,
        pattern: this._pattern
      };

      if (typeof this._minExclusive !== 'undefined') {
        values.minExclusive = this._minExclusive;
      }
      if (typeof this._maxExclusive !== 'undefined') {
        values.maxExclusive = this._maxExclusive;
      }
      if (typeof this._minInclusive !== 'undefined') {
        values.minInclusive = this._minInclusive;
      }
      if (typeof this._maxInclusive !== 'undefined') {
        values.maxInclusive = this._maxInclusive;
      }
      return values;
    }

    /**
     * Deserialize a parameter from a simple object.
     * @param {object} values The serialized parameter
     * @returns {OpenSearchParameter} The deserialized parameter
     */

  }, {
    key: 'type',
    get: function get() {
      return this._type;
    }

    /**
     * The name of the parameter
     * @readonly
     */

  }, {
    key: 'name',
    get: function get() {
      return this._name;
    }

    /**
     * Whether the parameter is mandatory
     * @readonly
     */

  }, {
    key: 'mandatory',
    get: function get() {
      return this._mandatory;
    }

    /**
     * The possible values for this parameter
     * @readonly
     */

  }, {
    key: 'options',
    get: function get() {
      return this._options;
    }

    /**
     * The minimum value allowed for this parameter (exclusive)
     * @readonly
     */

  }, {
    key: 'minExclusive',
    get: function get() {
      return this._minExclusive;
    }

    /**
     * The maximum value allowed for this parameter (exclusive)
     * @readonly
     */

  }, {
    key: 'maxExclusive',
    get: function get() {
      return this._maxExclusive;
    }

    /**
     * The minimum value allowed for this parameter (inclusive)
     * @readonly
     */

  }, {
    key: 'minInclusive',
    get: function get() {
      return this._minInclusive;
    }

    /**
     * The maximum value allowed for this parameter (inclusive)
     * @readonly
     */

  }, {
    key: 'maxInclusive',
    get: function get() {
      return this._maxInclusive;
    }

    /**
     * The pattern, serialized values have to conform to.
     * @readonly
     */

  }, {
    key: 'pattern',
    get: function get() {
      return this._pattern;
    }

    /**
     * Checks whether this parameter handles multiple sub-parameters.
     * e.g: time={time:start}/{time:end}
     * @readonly
     */

  }, {
    key: 'isMulti',
    get: function get() {
      return Array.isArray(this.type);
    }
  }], [{
    key: 'fromNode',
    value: function fromNode(node) {
      var type = parseType(node.getAttribute('value'));
      var name = node.getAttribute('name');
      var mandatory = node.hasAttribute('minimum') ? node.getAttribute('minimum') !== '0' : undefined;
      var minExclusive = node.hasAttribute('minExclusive') ? parseInt(node.getAttribute('minExclusive'), 10) : undefined;
      var maxExclusive = node.hasAttribute('maxExclusive') ? parseInt(node.getAttribute('maxExclusive'), 10) : undefined;
      var minInclusive = node.hasAttribute('minInclusive') ? parseInt(node.getAttribute('minInclusive'), 10) : undefined;
      var maxInclusive = node.hasAttribute('maxInclusive') ? parseInt(node.getAttribute('maxInclusive'), 10) : undefined;
      var pattern = node.hasAttribute('pattern') ? node.getAttribute('pattern') : undefined;
      var optionNodes = (0, _utils.getElements)(node, 'parameters', 'Option');
      var options = void 0;
      if (optionNodes.length) {
        options = optionNodes.map(function (optionNode) {
          return {
            label: optionNode.getAttribute('label'),
            value: optionNode.getAttribute('value')
          };
        });
      }
      return new OpenSearchParameter(type, name, mandatory, options, minExclusive, maxExclusive, minInclusive, maxInclusive, pattern);
    }

    /**
     * Constructs a new OpenSearchParameter from a key value pair (e.g: from the
     * query part of a KVP-URL). Returns null, when the value could not be parsed.
     * @param {DOMNode} key the key of the key-value-pair.
     * @param {DOMNode} value the value of the key-value-pair.
     * @returns {OpenSearchParameter|null} the constructed parameters object.
     */

  }, {
    key: 'fromKeyValuePair',
    value: function fromKeyValuePair(key, value) {
      var type = parseType(value);
      if (type) {
        var multi = value.match(typeREglobal);
        if (multi.length > 1) {
          var types = multi.map(parseType);
          var mandatory = multi.map(isMandatory).reduce(function (acc, v) {
            return acc || v;
          }, false);
          return new OpenSearchParameter(types, key, mandatory);
        }
        return new OpenSearchParameter(type, key, isMandatory(value));
      }
      return null;
    }
  }, {
    key: 'deserialize',
    value: function deserialize(values) {
      return new OpenSearchParameter(values.type, values.name, values.mandatory, values.options, values.minExclusive, values.maxExclusive, values.minInclusive, values.maxInclusive, values.pattern);
    }
  }]);

  return OpenSearchParameter;
}();


// WEBPACK FOOTER //
// /~/opensearch-browser/dist/parameter.js